const local = {
  gateway: { URL: 'http://localhost:8000' },
};

const customBuild = {
  gateway: { URL: process.env.REACT_APP_SERVICE_ENDPOINT },
};

function buildConfig() {
  switch (process.env.REACT_APP_STAGE) {
    case 'local':
      return local;
    default:
      return customBuild;
  }
}

export default { ...buildConfig() };
